import NavBar from "app/NavBar";
import EnforceManagerSession from "app/router/components/EnforceManagerSession";
import {
  AppContainer,
  MainContent,
  NavBarContainer,
  StandaloneContent,
} from "app/router/index.style";
import { HeaderSection } from "pages/home/components/HeaderSection";

export function AdminLayout({ children }) {
  return (
    <AppContainer>
      <EnforceManagerSession />
      <NavBarContainer>
        <NavBar />
      </NavBarContainer>
      <MainContent>
        <HeaderSection />
        {children}
      </MainContent>
    </AppContainer>
  );
}

export function PlainLayout({ element }) {
  return <StandaloneContent>{element}</StandaloneContent>;
}
